import React, { Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import AuthPortalFooterLinksPage from './components/AuthPortalFooterLinksPage';
import CenteredLoader from './components/CenteredLoader';
import { AUTH_PORTAL_FOOTER_PATH, HOME } from './config/navigationalRoutes';
import routeConfig from './routeConfig';
import HomePage from './pages/HomePage';

export default (
  <Suspense fallback={<CenteredLoader />}>
    <Switch>
      <Route exact path={HOME} component={HomePage} />
      {routeConfig.map(({ path, component }) => (
        <Route path={path} component={component} />
      ))}
      <Route
        path={AUTH_PORTAL_FOOTER_PATH}
        component={AuthPortalFooterLinksPage}
      />
      <Route render={() => <Redirect to={HOME} />} />
    </Switch>
  </Suspense>
);
